module.exports = __webpack_public_path__ + "img/play.798ec191.png";